export default {"src":"/_next/static/media/ic-youtube.b9324bdb.svg","height":32,"width":31};